import { t } from "@web-monorepo/i18n/macro";
import { DDSIconButton } from "@web-monorepo/dds";
import { IconX } from "@web-monorepo/dds-icons";
import styles from "./Header.module.css";

// Intentional non-breaking space — prevents the title div from
// collapsing to zero height when `title` is undefined (a regular space
// would collapse in block layout, leaving the header missing its row).
const nonBreakingSpace = " ";

// Header for the TeacherTips overlay — a close icon-button on the left
// + a centered title.
type HeaderProps = {
  onClose?: () => void;
  title?: string;
};

export default function Header({ onClose, title }: HeaderProps) {
  return (
    <header className={styles.header}>
      <DDSIconButton
        data-name="conundrums_header:close"
        aria-label={t`Close`}
        tooltip={{ content: t`Close`, dataName: "conundrums_header:close:tooltip" }}
        variant="transparent"
        className={styles.closeButton}
        onClick={onClose}
      >
        <IconX />
      </DDSIconButton>
      <div className={styles.title}>{title || nonBreakingSpace}</div>
    </header>
  );
}
